import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import * as appbaseTypes from '@appbase/store/types';
import api from '@hr/api/index'
//import ModalSlotLayout from './ModalSlotLayout.vue';
import ModalSlotLayout from '@appbase/containers/ModalContainer/ModalSlotLayout.vue'
import modalHelper from '@appbase/util/modal-helper'
import ModalLayout from '@appbase/templates/ModalLayout/ModalLayout.vue'
import {FormGroup, TextBoxField} from '@appbase/components/forms/index'


@Component({
    components: {
        ModalSlotLayout,
        ModalLayout,
        FormGroup,
        TextBoxField
    },
    computed: {
        ...mapGetters({
            isTeams: appbaseTypes.TEAMS,
        })
    } 
})
export default class Modify extends Vue {

    @Prop({ type: Object }) value!: any;

    isModal?: boolean = false;
    isTeams!: boolean
    
    targetId: string = ''

    leavemasterData: any = {

    }

    async save(){
        let _this = this;

         this.$nextTick(async()=>{

            if(_this.leavemasterData.assignDay===''||_this.leavemasterData.extraSpend===''){
                await (window as any).alertAsync(_this.$t('숫자를 입력하세요'));
                return;
            }

            api.leave.setLeaveManageAdmin({
                Id: _this.leavemasterData.id,
                AssignDay: parseFloat(_this.leavemasterData.assignDay),
                ExtraSpend: parseFloat(_this.leavemasterData.extraSpend),
                ModifyUser: ''
            }).then(async res=>{
                if(res==0){
                    await (window as any).alertAsync(_this.$t('휴가정보수정성공'));
                    _this.handleClose()
                }else{
                    await (window as any).alertAsync(_this.$t('휴가정보수정실패')+'\n' + res);
                }
            })
        })

    }

    handleClose() {
        if(this.isModal){
            modalHelper.close();
        }
        else{
            window.close()
        }
        
    }

    created(){
        var paramValue;
        if(this.value) {
            paramValue = this.value;
            this.isModal = true;
        }
        else{
            paramValue = this.$route.query
        }

    }

    mounted(){
        this.targetId = this.$route.query.id as string;

        api.leave.getLeaveManageAdmin(this.targetId).then(res=>{
            this.leavemasterData = res;
        });

    }
}